import defaultTheme from './defaultTheme';

const useDefaultTheme = () => {
  return defaultTheme;
};

export default useDefaultTheme;
